import { Mic, MicOff, Video, VideoOff } from "lucide-react";

import { TooltipProvider } from "@/components/ui/tooltip";
import { ActionButton } from "@/features/vidyo-call/components/action-button";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export function DeviceStatus() {
  const isCameraMuted = useVidyoStore((state) => state.camera.shouldBeMuted);
  const toggleCamera = useVidyoStore((state) => state.camera.toggle);

  const isMicrophoneMuted = useVidyoStore(
    (state) => state.microphone.shouldBeMuted,
  );
  const toggleMicrophone = useVidyoStore((state) => state.microphone.toggle);

  return (
    <div className="flex items-center rounded-md border border-input ring-4 ring-card [&>.action-button:last-of-type]:border-r-0 [&>.action-button]:border-r [&>.action-button]:border-input">
      <TooltipProvider>
        <ActionButton
          onClick={toggleCamera}
          Icon={isCameraMuted ? VideoOff : Video}
          tooltipText={isCameraMuted ? "Turn on" : "Turn off"}
          isActive={!isCameraMuted}
        />
        <ActionButton
          onClick={toggleMicrophone}
          Icon={isMicrophoneMuted ? MicOff : Mic}
          tooltipText={isMicrophoneMuted ? "Unmute" : "Mute"}
          isActive={!isMicrophoneMuted}
        />
      </TooltipProvider>
    </div>
  );
}
